<template>
    <div class="ar-times">
        <ul class="clearfix f-ul">
          <li v-for='(item, index) in tabmenu' :key="index" :class="{'on':index == TimeArray.flag}" @click="selectbydate(index) ">{{item.name}}</li>
          <li>请选择时间范围：</li>
          <li>
            <template>
              <div class="block">
                <el-date-picker
                    autocomplete="off" 
                    v-model="seltime"
                    type="datetimerange"    
                    @change="seltimeChange" 
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    range-separator="至"
                    :picker-options="TimeArray.isPicker == false ? '' : pickerBeginDateBefore"
                    :default-time="['00:00:00']"
                    >
                </el-date-picker>
              </div>
            </template>
          </li>
        </ul>
    </div>
</template>
<script>
export default {
    name: 'ArTimes',
    data(){
        return{
            tabmenu: [
                {'name': '1小时'}, 
                {'name': '6小时'}, 
                {'name': '12小时'}, 
                {'name': '1天内'}, 
                {'name': '3天内'}, 
            ],
            //时间选择器
            seltime:'',
            //超前时间不能获取
            pickerBeginDateBefore:{
                disabledDate(time) {
                    let timeSpace = time.getTime() > Date.now();
                    return timeSpace;
                }
            },
        }
    },
    props:['TimeArray'],
    mounted(){
        this.selectbydate(this.TimeArray.flag);
    },
    methods:{
        selectbydate(index) {
            this.seltime = '',
            this.TimeArray.endline = 0;
            this.TimeArray.begline = 0;
            this.TimeArray.flag = index;
            let thisDate = new Date();
            let h1 = 0, h6 = 1, h12 = 2, d1 = 3, d3 = 4;
            if(index === h1) {
                this.TimeArray.begline = thisDate.getTime() - 3600 * 1000;
                this.TimeArray.sumHours = 1;
            }else if(index === h6) {
                this.TimeArray.begline = thisDate.getTime() - 3600 * 6 * 1000;
                this.TimeArray.sumHours = 6;
            }else if(index === h12) {
                this.TimeArray.begline = thisDate.getTime() - 3600 * 12 * 1000;
                this.TimeArray.sumHours = 12;
            }else if(index === d1) {
                this.TimeArray.begline = thisDate.getTime() - 3600 * 24 * 1000;
                this.TimeArray.sumHours = 1*24;
            }else if(index === d3) {
                this.TimeArray.begline = thisDate.getTime() - 3600 * 3 * 24 * 1000;
                this.TimeArray.sumHours = 3*24;
            }
            this.TimeArray.endline = thisDate.getTime();
            this.submit();
        },
        //时间选择器
        seltimeChange() {
            this.TimeArray.flag =  undefined;
            var olddate = new Date(this.seltime[0]);
            var newdate = new Date(this.seltime[1]);
            this.TimeArray.begline = olddate.getTime();
            this.TimeArray.endline = newdate.getTime();
            this.submit();
        },
        submit(){
            //时间多少到多少
            let name = '';
            if(this.TimeArray.flag != undefined){
                name =  this.tabmenu[this.TimeArray.flag].name;
            }else{
                var dateOld = new Date(this.seltime[0]);  
                dateOld = dateOld.getFullYear() + '-' + (dateOld.getMonth() + 1) + '-' + dateOld.getDate();  
                var dateNew = new Date(this.seltime[1]);  
                dateNew = dateNew.getFullYear() + '-' + (dateNew.getMonth() + 1) + '-' + dateNew.getDate(); 
                name = dateOld + '至' + dateNew;
            }
            this.$emit('TimeSelector', name);
        },
    }
}
</script>
<style lang="scss" scoped>
.ar-times{
    height: 68px;
    background-color: #FFF;
    vertical-align: middle;
    padding: 16px 20px 0;
    box-sizing: border-box;
    .f-ul {
        height: 40px;
        width: auto;
        li {
            box-sizing: border-box;
            float: left;
            height: 36px;
            border: 2px solid #E4E4E4;
            line-height: 32px;
            min-width: 80px;
            padding: 0 20px;
            text-align: center;
            margin: 0 10px;
            color:#606060;
            cursor: pointer;
            font-size: 14px;
            border-radius: 18px;
            .el-range-editor.el-input__inner {
                border: 1px solid #DDD;
                width: 360px;
                padding: 3px 10px;
                background-color: #FFF;
                height: 36px;
                box-sizing: border-box;
                input {
                    font-size:14px;
                    background-color: #F7FAFC;
                }
                span{
                line-height: 36px;
                }
                .el-date-editor .el-range__icon {
                    line-height: 30px;
                }
            }
        }
        li:first-child{
            margin: 0 10px 0 0;  
        }
        li:nth-child(6),
        li:nth-child(7),
        li:nth-child(8),
        li:nth-child(9) {
            border: none !important;
            padding: 0;
            cursor: auto;
            border-radius: 0; 
        }
        li:nth-child(6):hover,
        li:nth-child(7):hover,
        li:nth-child(8):hover,
        li:nth-child(9):hover {
            border: none !important;
            color: #111;
            border-radius: 0; 
        }
        li.on,
        li.on:hover {
            position: relative;
            background:rgba(255,255,255,1);
            border:2px solid rgba(56,164,255,1);
            color: #38A4FF;
            &::after{
                content: '';
                position: absolute;
                bottom: -7px;
                left: 50%;
                transform: translate(-50%, 0);
                border-left: 4px solid transparent;
                border-right: 4px solid transparent;
                border-top: 6px solid #38A4FF;
            }
        }
        li:hover {
            border:2px solid rgba(56,164,255,1);
            color: #38A4FF;
        }
    }
}
</style>





// WEBPACK FOOTER //
// src/components/times/times.vue